import api from "./client";

export const authService = {
    register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
    login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
    me: () => api.get("/auth/me").then((r) => r.data),
    verifyEmail: (token) => api.post("/auth/verify", { token }).then((r) => r.data),
    resendVerification: (email) =>
        api.post("/auth/resend-verification", { email }).then((r) => r.data),
    forgotPassword: (email) =>
        api.post("/auth/forgot-password", { email }).then((r) => r.data),
    resetPassword: (token, password) =>
        api.post("/auth/reset-password", { token, password }).then((r) => r.data),
    changePassword: (currentPassword, newPassword) =>
        api
            .post("/auth/change-password", { currentPassword, newPassword })
            .then((r) => r.data),
};

export const predictionsService = {
    today: () => api.get("/predictions/today").then((r) => r.data),
    featured: () => api.get("/predictions/featured").then((r) => r.data),
    custom: (fixtures) =>
        api.post("/predictions/custom", { fixtures }).then((r) => r.data),
};

export const analyticsService = {
    me: (days = 30) =>
        api.get(`/users/me/analytics?days=${days}`).then((r) => r.data),
};

export const liveService = {
    scores: () => api.get("/live/scores").then((r) => r.data),
    fixture: (id) => api.get(`/live/fixture/${id}`).then((r) => r.data),
    byFixtures: (ids) => {
        const list = (ids || []).filter(Boolean).join("-");
        if (!list) return Promise.resolve({});
        return api.get(`/live/by-fixtures?ids=${list}`).then((r) => r.data);
    },
};

export const subscriptionService = {
    initialize: (callbackUrl) =>
        api
            .post("/subscription/initialize", { callbackUrl })
            .then((r) => r.data),
    verify: (reference) =>
        api.get(`/subscription/verify/${reference}`).then((r) => r.data),
};

export const fantasyService = {
    status: () => api.get("/fantasy/status").then((r) => r.data),
    link: (teamId) =>
        api.post("/fantasy/link", { team_id: Number(teamId) }).then((r) => r.data),
    unlink: () => api.delete("/fantasy/link").then((r) => r.data),
    advice: (refresh = false) =>
        api
            .get(`/fantasy/advice${refresh ? "?refresh=true" : ""}`)
            .then((r) => r.data),
    captainOfTheWeek: (gameweek) =>
        api
            .get(
                `/fantasy/captain-of-the-week${
                    gameweek ? `?gameweek=${gameweek}` : ""
                }`
            )
            .then((r) => r.data),
};
